import React, { useState, useContext } from 'react';
import { Button, TextField, Grid, Typography, Container, Paper } from '@material-ui/core';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Assignment, Phone, PhoneDisabled } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

import { SocketContext } from '../Context';

import styled from 'styled-components';

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
  },
}));

const StyledTextField = styled(TextField)`

/* この指定の仕方を覚える */
  label.Mui-focused {
    color: white;
  }
  .MuiFormLabel-root {
    color:white;
  }

  .MuiInput-underline:after {
    border-bottom: 1px solid white;
}

.MuiInputBase-input {
    text-align: center;
}




  .MuiOutlinedInput-root {
    fieldset {
      border-color: red;
    }
    &:hover fieldset {
      border-color: yellow;
    }
    &.Mui-focused fieldset {
      border-color: green;
    }
  }
`;

const Sidebar = ({ children }) => {
  const { me, callAccepted, name, setName, callEnded, leaveCall, callUser } = useContext(SocketContext);
  const [idToCall, setIdToCall] = useState('');
  const classes = useStyles();


  return (
    <div class="mt-10 p-10 space-y-20">

      <div class="space-y-5">
        <h2 class="text-center text-3xl text-white">YOU</h2>
        <CopyToClipboard text={me}>
          <Button variant="contained" color="primary" fullWidth startIcon={<Assignment fontSize="large" />}>
            Copy Your ID and send it to a partner
          </Button>
        </CopyToClipboard>
        {children}

      </div>



      <div class="space-y-5">
        <h2 class="text-center text-3xl text-white">PARTNER</h2>
        <StyledTextField label="Paste the received ID"
          value={idToCall} onChange={(e) => setIdToCall(e.target.value)}
          fullWidth />
        {callAccepted && !callEnded ? (
          <Button variant="contained" color="secondary" startIcon={<PhoneDisabled fontSize="large" />} fullWidth onClick={leaveCall} className={classes.margin}>
            Hang Up
          </Button>
        ) : (
          <Button variant="contained" color="secondary" startIcon={<Phone fontSize="large" />} fullWidth onClick={() => callUser(idToCall)} className={classes.margin}>
            Call
          </Button>
        )}
      </div>
    </div >
  );
};

export default Sidebar;
